import { render, staticRenderFns } from "./onlinemall.vue?vue&type=template&id=7cdd5d60&scoped=true&"
import script from "./onlinemall.vue?vue&type=script&lang=js&"
export * from "./onlinemall.vue?vue&type=script&lang=js&"
import style0 from "./onlinemall.vue?vue&type=style&index=0&id=7cdd5d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdd5d60",
  null
  
)

export default component.exports